import { AppContent } from '@dtx-company/inter-app/src/redux/slices/app-content-slice'
import { RootState } from '@dtx-company/inter-app/src/redux/types'
import { useSelector } from 'react-redux'

export const useAppContent = (): AppContent => {
  const appContent = useSelector((state: RootState) => state.appReducer.appContentSlice)
  if (!appContent) {
    throw new Error('App Content missing, must inject slice into createReduxStore')
  }
  return appContent
}
